<template>
    <ListenerQueueDetails v-if="isListenerMobile" />
    <Queue v-else />
</template>

<script>
import Queue from './Queue.vue'
import ListenerQueueDetails from './ListenerQueueDetails.vue'

export default {
    name: 'QueueEntry',
    components: {
        Queue,
        ListenerQueueDetails
    },
    computed: {
        isListenerMobile() {
            return !this.$store.state.common.isSuperuser
                && typeof window !== 'undefined'
                && window.innerWidth <= 768
        }
    }
}
</script>
